import { supabase } from "../backend/supabase";

export async function getCurrentToken() {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
        console.error("Error fetching session:", error);
        return null;
    }

    if (session) {
        // The JWT token is in session.access_token
        return session.access_token;
    }
    
    return null; // No active session
}